import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getSelectedGroupId } from 'ducks/products';
import { useSpring } from 'react-spring';
import ProductGroupNav from 'components/ProductSidebar/ProductGroupNav/ProductGroupNav';
import ProductMenu from './ProductMenu/ProductMenu';
import SelectedMenu from './SelectedMenu/SelectedMenu';
import UnavailableProductsMenu from '../menus/UnavailableProductsMenu/UnavailableProductsMenu';
import UnavailableFramesMenu from '../menus/UnavailableFramesMenu/UnavailableFramesMenu';
import SceneMenu from './SceneMenu/SceneMenu';
import RotateDevice from 'components/RotateDevice/RotateDevice';
import { useSelected } from 'contexts/selected';
import ConflictMenu from '../menus/ConflictMenu/ConflictMenu';
import { getSelectedEntity } from 'ducks/core';
import { e2e, getRange } from 'utils/queryUtils';
import UncoupledSlidingDoorsMenu from '../menus/UncoupledSlidingDoorsMenu/UncoupledSlidingDoorsMenu';
import InvalidPlacedEntityMenu from '../menus/InvalidPlacedEntityMenu/InvalidPlacedEntityMenu';

const NavigationWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

const Wrapper = styled.div`
  height: 8.75rem;
  background: white;
  position: fixed;
  bottom: 0;
`;

const MobileMenu = () => {
  const navigationRef = useRef<HTMLDivElement>(null);
  const { visible } = useSelected();
  const entitySelected = !!useSelector(getSelectedEntity);

  const showContentMenu = useSelector(getSelectedGroupId) ? true : false;
  const showSelectedMenu = visible;

  const [navigationHeight, setNavigationHeight] = useState(0);

  const menuContentHeight = 252;
  const menuSelectedHeight = 252;

  const getSceneOffset = () => {
    const largestHeight =
      menuSelectedHeight > menuContentHeight ? menuSelectedHeight : menuContentHeight;

    if (showContentMenu && showSelectedMenu) {
      return largestHeight - navigationHeight;
    }
    if (showContentMenu) {
      return menuContentHeight - navigationHeight;
    }
    if (showSelectedMenu) {
      return menuSelectedHeight - navigationHeight;
    }
    return 0;
  };

  const animationSceneMenu = useSpring({
    position: getSceneOffset(),
    viewerHeight: getSceneOffset() > 0 ? window.innerHeight : window.innerHeight - getSceneOffset()
  });

  const animationContentMenu = useSpring({
    menuHeight: showContentMenu ? menuContentHeight : 0,
    immediate: e2e()
  });

  const animationSelectedMenu = useSpring({
    menuHeight: showSelectedMenu ? menuSelectedHeight : 0,
    immediate: e2e()
  });

  useEffect(() => {
    if (navigationRef.current) {
      const height = navigationRef.current.getBoundingClientRect().height;
      setNavigationHeight(height);
    }
  }, [navigationRef]);

  return (
    <>
      <RotateDevice />
      <ConflictMenu />
      {getRange() === 'platsa' && <UncoupledSlidingDoorsMenu />}
      {getRange() === 'smastad' && <InvalidPlacedEntityMenu />}
      <SceneMenu
        animationProps={animationSceneMenu}
        bottomOffset={navigationHeight}
        selected={entitySelected}
      />
      <Wrapper>
        <NavigationWrapper ref={navigationRef}>
          <ProductGroupNav />
        </NavigationWrapper>
        <ProductMenu animationProps={animationContentMenu} height={menuContentHeight} />

        <SelectedMenu animationProps={animationSelectedMenu} height={menuSelectedHeight} />
      </Wrapper>
      <UnavailableProductsMenu />
      <UnavailableFramesMenu />
    </>
  );
};

export default MobileMenu;
